import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const ProductCardSkeleton = () => {
  return (
    <div className="product-list">
      <div className="product-items">
        <Skeleton height={150} width={150} />

        <div className="wishlist-products" style={{ marginTop: "8px" }}>
          <Skeleton circle width={30} height={30} />

          <small className="product-stage ">
            <Skeleton width={70} height={25} />
          </small>
        </div>
      </div>
      <div className="product-details" style={{ marginTop: "10px" }}>
        <h6 className="product-title">
          <Skeleton width={`80%`} height={16} />
        </h6>
        <div
          className="product-price"
          style={{ display: "flex", alignItems: "center", gap: "8px" }}
        >
          <Skeleton width={60} height={20} />
          <Skeleton circle width={20} height={20} />
        </div>
        <div className="product-code" style={{ marginTop: "5px" }}>
          <Skeleton width={100} height={14} />
        </div>
        <div
          className="product-button button-effect"
          style={{ marginTop: "10px" }}
        >
          <Skeleton width="100%" height={36} />
        </div>
      </div>
    </div>
  );
};
